<div
    *ngFor="let supplier of ceasedSupplierCmsKeys"
    class="supplierCeasedTrading alert alert-warning"
    role="alert"
>
    {{ supplier.cmskey | cmsText : [{ supplierName: supplier.name }] | async }}
</div>
